import { useReducedMotion } from 'framer-motion';

import {
  GUIDED_STEP_MOTION_EASE,
  guidedStepCardReducedMotionVariants,
  guidedStepCardSlideVariants,
} from '../../constants';

/**
 * ### useGuidedStepCardTransition
 *
 * @description
 * Returns Framer Motion config for guided step card cross-slide animations (Material
 * fast-out–slow-in on enter, standard acceleration on exit — see slide variants), or
 * instant reduced-motion fallbacks when the user prefers less motion.
 *
 * @returns `{ variants }` for slide timing (easing lives on variants); `{ transition, variants }` when reduced motion is on
 */
const useGuidedStepCardTransition = () => {
  const reduceMotion = useReducedMotion();
  if (reduceMotion) {
    return {
      transition: { duration: 0, ease: GUIDED_STEP_MOTION_EASE } as const,
      variants: guidedStepCardReducedMotionVariants,
    } as const;
  }
  return {
    variants: guidedStepCardSlideVariants,
  } as const;
};

export default useGuidedStepCardTransition;
